export const Ease = {
  getEase:(easing)=>{
    let ease;
    switch (easing) {
      case "easeOutExpo": ease = function (t, b, c, d) {
          return (t == d) ? b + c: c * (-Math.pow(2, -10 * t / d) + 1) + b;
        }
        break;
      case "easeInOutExpo": ease = function (t, b, c, d) {
          if (t == 0) return b;
          if (t == d) return b + c;
          if ((t /= d / 2) < 1) return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
          return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
        }
        break;

      // case "easeOutQuart": ease = function (t, b, c, d) {
      //     return -c * ((t = t / d - 1) * t * t * t - 1) + b;
      //   }
      //   break;
    }
    return ease;
  },

}


// export let Ease = (time, easing, delay)=> {
//   return motion = (()=>{

//     let req=null;

//     let ease = getEasing(); // 使用するイージング関数
//     let progress = 0;
//     let easeProgress = 0;

//     let update = (timestamp) => {
//       // 遅延時間を含めた進捗率を算出
//       progress = (timestamp - delay) / time;

//       // 進捗率が100%を超えないよう丸める
//       progress = Math.min(progress, 1);
      
//       // 進捗率がプラスの場合のみ値を算出し反映する
//       if (progress >= 0) {
//         easeProgress = ease(progress, 0, 1, 1); // 進捗率からイージング関数を通した変化割合を算出
//       }
      
//       // 進捗が1未満の場合はアップデートを再実行する
//       if (progress < 1) {
//         req=requestAnimationFrame(update);
//       }
//       else{
//         cancel()
//       } 
//       return progress;
//     }

//     req=requestAnimationFrame(update);


//     let getEasing=()=>{
//       let ease;
//       switch (easing) {
//         case "easeOutExpo": ease = function (t, b, c, d) {
//             return (t == d) ? b + c: c * (-Math.pow(2, -10 * t / d) + 1) + b;
//           }
//           break;
//         case "easeInOutExpo": ease = function (t, b, c, d) {
//             if (t == 0) return b;
//             if (t == d) return b + c;
//             if ((t /= d / 2) < 1) return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
//             return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
//           }
//           break;
//       }
//       return ease;
//     }



//     let cancel=()=>{
//       cancelAnimationFrame(req)
//     }

    
//   })()


//   // motion:(time, easing, delay)=>{
//   //   const ease = getEasing(easing); // 使用するイージング関数
//   //   let progress = 0;
//   //   let easeProgress = 0;

//   //   Ease.req=requestAnimationFrame(update);

//   //   return update = (timestamp) =>{
//   //     // 遅延時間を含めた進捗率を算出
//   //     progress = (timestamp - delay) / time;

//   //     // 進捗率が100%を超えないよう丸める
//   //     progress = Math.min(progress, 1);
      
//   //     // 進捗率がプラスの場合のみ値を算出し反映する
//   //     if (progress >= 0) {
//   //       easeProgress = ease(progress, 0, 1, 1); // 進捗率からイージング関数を通した変化割合を算出
//   //     }
      
//   //     // 進捗が1未満の場合はアップデートを再実行する
//   //     if (progress < 1) {
//   //       Ease.req=requestAnimationFrame(update);
//   //     }
//   //     else{
//   //       Ease.cancel()
//   //     }

//   //     return progress;
//   //   }

    

//   // },
//   // update:()=>{

//   // },
//   // cancel:()=>{
//   //   cancelAnimationFrame(Ease.req)
//   // },
//   // getEasing:(easingName)=>{
//   //   let ease;
//   //   switch (easingName) {
//   //     case "easeOutExpo": ease = function (t, b, c, d) {
//   //         return (t == d) ? b + c: c * (-Math.pow(2, -10 * t / d) + 1) + b;
//   //       }
//   //       break;
//   //     case "easeInOutExpo": ease = function (t, b, c, d) {
//   //         if (t == 0) return b;
//   //         if (t == d) return b + c;
//   //         if ((t /= d / 2) < 1) return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
//   //         return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
//   //       }
//   //       break;
//   //   }
//   //   return ease;
//   // }
// };